<template>
  <!-- 디자인 시스템: 재화 compact 표시 — 🥕 아이콘 + 숫자만 (배경/버튼 없음). 테마 자동(Themeable). -->
  <span class="currency-count" :class="{ 'currency-count--dark': isDark }">
    <span class="currency-count__emoji">🥕</span>
    <span class="currency-count__num">{{ (balance || 0).toLocaleString() }}</span>
  </span>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "AppCurrencyCount",
  mixins: [Themeable], // isDark(컨텍스트/앱 테마 상속) + dark/light prop 오버라이드
  props: {
    balance: { type: Number, default: 0 }, // 당근 잔액
  },
};
</script>

<style scoped>
.currency-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.currency-count__emoji {
  font-size: 14px;
  line-height: 1;
}
.currency-count__num {
  font-weight: 700;
  color: #9a6a18; /* 라이트: 진한 골드 */
  font-size: 14px;
}
/* 다크: 배경이 어두우니 밝은 골드로 대비 확보 */
.currency-count--dark .currency-count__num {
  color: #f0c15a;
}
</style>
